/* globals google */
;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.mapClickHandlerInitialized = false

  eah.map = (function () {
    let API_KEY = 'AIzaSyBjdutsio64yJqZYpE7aRu66Awpr-oXlas'
    let markers = {}
    let mapOptions = {}
    let loaded = false

    function addScript (url, callback) {
      var script = document.createElement('script')
      if (callback) script.onload = callback
      script.type = 'text/javascript'
      script.src = url
      document.body.appendChild(script)
    }

    function loadMapsAPI () {
      if (!loaded) {
        addScript('//maps.google.com/maps/api/js?key=' + API_KEY + '&libraries=places&callback=eah.map.ready')
      }
    }

    function ready () {
      // console.log('map ready', mapOptions)
      loaded = true
      setTimeout(function () {
        createMap(mapOptions)
      }, 500)
    }

    function initialize (mapOptionsIn) {
      // console.log('map init', this, mapOptionsIn, mapOptions)
      mapOptions = mapOptionsIn
      if (!loaded) {
        loadMapsAPI()
      } else {
        ready()
      }

      if (eah.mapClickHandlerInitialized) {
        return
      }

      $('.map-container .ctl-overlay a').on('click', function (e) {
        const $btn = $(e.target)
        const $overlay = $btn.closest('.ctl-overlay')
        const lbl = ($overlay.hasClass('disabled')) ? 'Enable' : 'Disable'
        $btn.text(lbl + ' the map')
        $overlay.toggleClass('disabled')
        return false
      })

      eah.mapClickHandlerInitialized = true
    }

    function getCommunityMarker (location) {
      let customIcon = 'https://www.eahomes.com/wp-content/themes/eahomes/dist/assets/img/eah-map-marker.png'

      // if they have a custom icon defined, use that.
      if (location.customIcon !== '' && typeof location.customIcon !== 'undefined') {
        customIcon = location.customIcon
        // console.log('custom icon', customIcon, /www\.eahomes\.com/.test(customIcon), /^http/.test(customIcon))
        if (!/www\.eahomes\.com/.test(customIcon) && /^http/.test(customIcon)) {
          customIcon = customIcon.replace(window.location.origin, 'https://www.eahomes.com')
        }
        // console.log('custom icon 2', customIcon)
      }

      return customIcon
    }

    function createMap (mapOptions) {
      const defaultOptions = {
        // mapElement: HTML Element where map is placed
        // mapLocations: Array of locations to map
        markerCallback: false,
        showNearby: true,
        showInfoBox: true,
        openAtStart: null
      }

      const options = $.extend(defaultOptions, mapOptions)
      // const directionsUrl = 'https://maps.google.com/maps?daddr='

      // if you have no locations to map, just stop the show
      if (!options.mapLocations || !options.mapLocations.length) {
        return
      }

      // if there is only one location, we do a few things differently
      if (options.mapLocations.length === 1) {
        options.singleLocation = true
      }

      // dynamic variable names so we can have more than one google map on the page
      eah.mapCnt = eah.mapCnt || 0
      eah.maps = eah.maps || {}
      eah.mapCnt++
      const mapName = 'eahMap' + eah.mapCnt
      // window.console && console.log('About to initialize ' + mapName);

      // need to determine if we are a feature map which will change where we place the zoom controls
      // const isFeature = !!$(options.mapElement).parents('section.featureMap, section.featureArea').length

      eah.maps[ mapName ] = new google.maps.Map(options.mapElement, {
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: mapStyles,
        zoomControl: true,
        zoomControlOptions: {
          style: google.maps.ZoomControlStyle.SMALL,
          position: google.maps.ControlPosition.BOTTOM_CENTER
        },
        scaleControl: false,
        panControl: false,
        streetViewControl: false,
        mapTypeControl: false,
        scrollwheel: false
      })

      // create empty LatLngBounds object and other vars for google maps
      const bounds = new google.maps.LatLngBounds()
      let infowindowList = []
      // let marker = null
      let i = null

      // window.console && console.log(options);

      // place communities on map
      for (i = 0; i < options.mapLocations.length; i++) {
        let thisLocation = options.mapLocations[ i ]
        let customIcon = getCommunityMarker(thisLocation)

        if (!thisLocation.latitude || !thisLocation.longitude) {
          continue
        }

        const markerPos = new google.maps.LatLng(thisLocation.latitude, thisLocation.longitude)

        const marker = new google.maps.Marker({
          position: markerPos,
          comingSoon: thisLocation.isComingSoon,
          structure: thisLocation.structure,
          devStatus: thisLocation.devStatus,
          icon: customIcon,
          zIndex: 100,
          map: eah.maps[ mapName ]
        })

        // if ($('.masthead.communities').length) {
        //
        // }

        const markerContent = [
          '<div class="map-communityWrap">',
          '<div class="map-communityTitle"><a class="community-link-hook" href="' + thisLocation.url + '">' + thisLocation.name + '</a></div>',
          '<div class="map-communityLocation">', thisLocation.area, '</div>',
          '<hr>',
          '<div class="map-communityPrice">', thisLocation[ 'dateOrPrice' ], '</div>',
          // '<div class="button secondary simple"><div class="contentWrap"><a href="', thisLocation.directionsLink, '" target="_blank"><span class="text">Get Directions</span></a></div></div>',
          '<div class="button secondary simple"><div class="contentWrap"><a href="', thisLocation.url, '"><span class="text">Explore Community</span></a></div></div>',
          '<div class="map-communityLinks">',
          '<a data-track-conversion href="#" class="" onClick="eah.conciergeForm.open(this); return false;" data-community-name="', thisLocation.shortName, '" data-open-concierge-form >Request Information</a>',

          (thisLocation.directionsPDF !== '' ? ' | <a target="_blank" data-track-conversion class="" href="' + thisLocation.directionsPDF + '">Print Directions</a>' : ''),
          '</div>',
          '</div>'
        ].join('')

        // extend the bounds to include each marker's position
        bounds.extend(marker.position)

        const iw = new google.maps.InfoWindow({
          // maxWidth: 380
        })
        infowindowList.push(iw)

        // If a location specifies, do not make it open an infobox.
        if (!thisLocation.notCommunity) {
          google.maps.event.addListener(marker, 'click', (function (marker, i, markerContent, thisLocation) {
            return function () {
              // we only show infobox if passed as true, but we show regardless if it is a single location
              // (Except on Home Inspiration page where map is used to show the Design Center location)
              if ((options.showInfoBox || options.singleLocation) && ($('header.home-inspiration').length === 0) && ($('div.design-center .feature-map').length === 0)) {
                // close all of the open infoQindows
                for (let j = 0, l = infowindowList.length; j < l; j++) {
                  infowindowList[ j ].close()
                }
                infowindowList[ i ].setContent(markerContent)
                infowindowList[ i ].open(eah.maps[ mapName ], marker)
              } else {
                window.console && console.log(options.showInfoBox)
                window.console && console.log(options.singleLocation)
                window.console && console.log($('header.home-inspiration'))
                window.console && console.log($('div.design-center'))
              }
              // center map on this marker
              eah.maps[ mapName ].panTo(marker.getPosition())

              // fire callback, if defined
              if (typeof options.markerCallback === 'function') {
                options.markerCallback(thisLocation, 'open')
              }
            }
          })(marker, i, markerContent, thisLocation))

          google.maps.event.addListener(infowindowList[ i ], 'closeclick', (function (marker, options) {
            return function () {
              reCenterMap()

              // fire callback, if defined
              if (typeof options.markerCallback === 'function') {
                options.markerCallback(thisLocation, 'close')
              }
            }
          })(marker, options))
        }

        markers[ thisLocation.id ] = marker
      }

      reCenterMap()

      function reCenterMap () {
        // let zoomLevel = (options.singleLocation) ? 13 : 10
        //
        // if (options.homepageSmallMap) {
        //   zoomLevel = 7
        // }
        //
        // if (options.neighborhoodMap) {
        //   zoomLevel = 10
        // }

        // window.console && console.log("I am setting the zoom here to " + zoomLevel);

        // zooms us out a bit to make sure all points fit on screen
        // var listener = google.maps.event.addListenerOnce(eah.maps[mapName], "zoom_changed", function () {
        //   eah.maps[mapName].setZoom(zoomLevel);
        // });

        // now fit the map to the newly inclusive bounds
        eah.maps[ mapName ].fitBounds(bounds)
      }

      // show schools if they want them
      // NOTE: This functionality is temporarily disabled
      if (options.showNearby) {
        // mapPlaces(bounds, eah.maps[mapName]);
      }

      // const mapCenter = bounds.getCenter()
      // re-center map on window re-size
      // google.maps.event.addDomListener(window, 'resize', function () {
      //   eah.maps[mapName].setCenter(mapCenter);
      // });

      function mapPlaces (bounds, map) { // eslint-disable-line no-unused-vars
        let request = {}

        if (options.singleLocation) {
          request = {
            location: bounds.getCenter(),
            radius: '5000',
            types: [ 'school' ] // , 'restaurant', 'shopping_mall'
          }
        } else {
          request = {
            bounds: bounds,
            types: [ 'school' ] // , 'restaurant', 'shopping_mall'
          }
        }

        // put points of interest on map
        const service = new google.maps.places.PlacesService(map)
        service.nearbySearch(request, callback)

        function callback (results, status) {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            for (let i = 0; i < results.length; i++) {
              createMarker(results[ i ])
            }
          }
        }

        function createMarker (place) {
          const placeLoc = place.geometry.location
          const type = place.types[ 0 ]
          const placesWindow = new google.maps.InfoWindow()
          let markerIcon = null

          switch (type) {
            case 'school':
              markerIcon = '/wp-content/themes/eahomes/dist/assets/img/eah-school-marker.png'
              break
            case 'university':
              markerIcon = '/wp-content/themes/eahomes/dist/assets/img/eah-school-marker.png'
              break
            case 'restaurant':
              markerIcon = '/wp-content/themes/eahomes/dist/assets/img/eah-restaurant-marker.png'
              break
            case 'shopping_mall':
              markerIcon = '/wp-content/themes/eahomes/dist/assets/img/eah-shopping-marker.png'
              break
            default:
              markerIcon = '/wp-content/themes/eahomes/dist/assets/img/eah-school-marker.png'
              break
          }

          const marker = new google.maps.Marker({
            map: map,
            position: placeLoc,
            zIndex: 50,
            icon: markerIcon
          })

          google.maps.event.addListener(marker, 'click', (function (marker, place, placesWindow, map) {
            return function () {
              placesWindow.setContent('<div class="placeMarker">' + place.name + '</div>')
              placesWindow.open(map, marker)
              $('.gm-style-iw').next('div').css('top', '9px') // hackity hack hack
            }
          })(marker, place, placesWindow, map))
        }
      }

      // Closed / Sold Out communities default to invisible. They must be deliberately revealed by a page action.
      // 1/26/2016 No longer distinguishing by active status, but by structure type. Commenting this out. ZPG
      /*
       for (var key in markers) {
       if (markers.hasOwnProperty(key)) { // Good practice when iterating through an object, to eliminate prototype properties
       //window.console && console.log(markers[key]['devStatus']);
       markers[key].setVisible(markers[key]['devStatus'] != 'closed');
       }
       } */

      // If we are on the homepage and the Featured Map is present, attempt to attach listeners to the filter buttons that hide/show markers
      if ($('.homepage .featureMap').length) {
        google.maps.event.addDomListener(document.getElementById('show-all'), 'click', function (event) {
          for (let j = 0, l = infowindowList.length; j < l; j++) {
            infowindowList[ j ].close()
          }
          // Iterate through map markers, make them all visible.
          for (let key in markers) {
            if (markers.hasOwnProperty(key)) { // Good practice when iterating through an object, to eliminate prototype properties
              markers[ key ].setVisible(true)
            }
          }
          $('.featureMap a.active').removeClass('active')
          $('.featureMap #show-all').addClass('active')
          event.preventDefault()
        })

        if ($('#show-coming-soon').length) {
          google.maps.event.addDomListener(document.getElementById('show-comingsoon'), 'click', function (event) {
            for (let j = 0, l = infowindowList.length; j < l; j++) {
              infowindowList[ j ].close()
            }
            // Iterate through map markers, hide Actives, show ComingSoons. visible.
            for (let key in markers) {
              if (markers.hasOwnProperty(key)) { // Good practice when iterating through an object, to eliminate prototype properties
                markers[ key ].setVisible(markers[ key ][ 'comingSoon' ] === true)
              }
            }
            $('.featureMap a.active').removeClass('active')
            $('.featureMap #show-comingsoon').addClass('active')
            event.preventDefault()
          })
        }

        if ($('#show-active').length) {
          google.maps.event.addDomListener(document.getElementById('show-active'), 'click', function (event) {
            for (let j = 0, l = infowindowList.length; j < l; j++) {
              infowindowList[ j ].close()
            }
            // Iterate through map markers, hide Actives, show ComingSoons. visible.
            for (let key in markers) {
              if (markers.hasOwnProperty(key)) { // Good practice when iterating through an object, to eliminate prototype properties
                markers[ key ].setVisible(markers[ key ][ 'comingSoon' ] === false)
              }
            }
            $('.featureMap a.active').removeClass('active')
            $('#show-active').addClass('active')
            event.preventDefault()
          })
        }

        if ($('#show-single-family').length) {
          google.maps.event.addDomListener(document.getElementById('show-single-family'), 'click', function (event) {
            for (let j = 0, l = infowindowList.length; j < l; j++) {
              infowindowList[ j ].close()
            }
            // Iterate through map markers, hide Actives, show ComingSoons. visible.
            for (let key in markers) {
              if (markers.hasOwnProperty(key)) { // Good practice when iterating through an object, to eliminate prototype properties
                markers[ key ].setVisible(markers[ key ][ 'structure' ] === 'single-family')
              }
            }
            $('.featureMap a.active').removeClass('active')
            $('.featureMap #show-single-family').addClass('active')
            event.preventDefault()
          })
        }

        if ($('#show-townhome').length) {
          google.maps.event.addDomListener(document.getElementById('show-townhome'), 'click', function (event) {
            for (let j = 0, l = infowindowList.length; j < l; j++) {
              infowindowList[ j ].close()
            }
            // Iterate through map markers, hide Actives, show ComingSoons. visible.
            for (let key in markers) {
              if (markers.hasOwnProperty(key)) { // Good practice when iterating through an object, to eliminate prototype properties
                markers[ key ].setVisible(markers[ key ][ 'structure' ] === 'townhome')
              }
            }
            $('.featureMap a.active').removeClass('active')
            $('#show-townhome').addClass('active')
            event.preventDefault()
          })
        }
      }

      /*
       // If we are on the search results page, attempt to attach listeners to the filter buttons that hide/show markers
       if ($('#hide-mirh').length) {
       google.maps.event.addDomListener(document.getElementById('hide-mirh'), 'click', function (event) {
       for (var j = 0, l = infowindowList.length; j < l; j++) {
       infowindowList[j].close();
       }

       // Iterate through map markers, hide Actives, show ComingSoons. visible.

       for (var key in markers) {
       if (markers.hasOwnProperty(key)) { // Good practice when iterating through an object, to eliminate prototype properties
       //window.console && console.log(markers[key]['devStatus']);
       markers[key].setVisible(($('#hide-mirh').attr('checked') != 'checked') || markers[key]['hasHomes']);
       }
       }
       //event.preventDefault();
       });
       }
       */

      const $viewAsControls = $('.controls--view-as')
      if ($viewAsControls.length) {
        $('.control--view-as').on('click', function (e) {
          const $e = $(e.target)
          const viewAs = $e.data('view-as')

          $('.control--view-as').removeClass('active')
          $e.addClass('active')
          if (viewAs === 'list') {
            $viewAsControls.siblings('.map-container').addClass('hidden')
            $viewAsControls.siblings('.list-container').removeClass('hidden')
          } else {
            $viewAsControls.siblings('.map-container').removeClass('hidden')
            $viewAsControls.siblings('.list-container').addClass('hidden')
          }

          e.preventDefault()
        })
      }

      // If we are on the communities page, attempt to attach listeners to the filter buttons that hide/show markers
      if ($('.communitiesMap').length) {
        google.maps.event.addDomListener(document.getElementById('show-all'), 'click', function (event) {
          for (let j = 0, l = infowindowList.length; j < l; j++) {
            infowindowList[ j ].close()
          }
          // Iterate through map markers, make all that aren't in Closed status visible.
          for (let key in markers) {
            if (markers.hasOwnProperty(key)) { // Good practice when iterating through an object, to eliminate prototype properties
              // window.console && console.log(markers[key]['devStatus']);
              markers[ key ].setVisible(true) // was (markers[key]['devStatus'] != 'closed');
            }
          }
          $('.gridControls li.is-selected').removeClass('is-selected')
          $('#show-all').parent().addClass('is-selected')
          event.preventDefault()
        })

        if ($('#show-coming-soon').length) {
          google.maps.event.addDomListener(document.getElementById('show-coming-soon'), 'click', function (event) {
            for (let j = 0, l = infowindowList.length; j < l; j++) {
              infowindowList[ j ].close()
            }
            // Iterate through map markers, hide Actives, show ComingSoons. visible.
            for (let key in markers) {
              if (markers.hasOwnProperty(key)) { // Good practice when iterating through an object, to eliminate prototype properties
                // window.console && console.log(markers[key]['devStatus']);
                markers[ key ].setVisible(markers[ key ][ 'devStatus' ] === 'coming-soon')
              }
            }
            $('.gridControls li.is-selected').removeClass('is-selected')
            $('#show-coming-soon').parent().addClass('is-selected')
            event.preventDefault()
          })
        }

        if ($('#show-ready').length) {
          google.maps.event.addDomListener(document.getElementById('show-ready'), 'click', function (event) {
            for (let j = 0, l = infowindowList.length; j < l; j++) {
              infowindowList[ j ].close()
            }
            // Iterate through map markers, hide Actives, show ComingSoons. visible.
            for (let key in markers) {
              if (markers.hasOwnProperty(key)) { // Good practice when iterating through an object, to eliminate prototype properties
                // window.console && console.log(markers[key]['devStatus']);
                markers[ key ].setVisible(markers[ key ][ 'devStatus' ] === 'ready')
              }
            }
            $('.gridControls li.is-selected').removeClass('is-selected')
            $('#show-ready').parent().addClass('is-selected')
            event.preventDefault()
          })
        }

        if ($('#show-closed').length) {
          google.maps.event.addDomListener(document.getElementById('show-closed'), 'click', function (event) {
            for (let j = 0, l = infowindowList.length; j < l; j++) {
              infowindowList[ j ].close()
            }
            // Iterate through map markers, hide Actives, show ComingSoons. visible.
            for (let key in markers) {
              if (markers.hasOwnProperty(key)) { // Good practice when iterating through an object, to eliminate prototype properties
                // window.console && console.log(markers[key]['devStatus']);
                markers[ key ].setVisible(markers[ key ][ 'devStatus' ] === 'closed')
              }
            }
            $('.gridControls li.is-selected').removeClass('is-selected')
            $('.featureMap #show-closed').parent().addClass('is-selected')
            event.preventDefault()
          })
        }

        if ($('#show-single-family').length) {
          google.maps.event.addDomListener(document.getElementById('show-single-family'), 'click', function (event) {
            for (let j = 0, l = infowindowList.length; j < l; j++) {
              infowindowList[ j ].close()
            }
            // Iterate through map markers, hide Actives, show ComingSoons. visible.
            for (let key in markers) {
              if (markers.hasOwnProperty(key)) { // Good practice when iterating through an object, to eliminate prototype properties
                // window.console && console.log(markers[key]['devStatus']);
                markers[ key ].setVisible(markers[ key ][ 'structure' ] === 'single-family')
              }
            }
            $('.gridControls li.is-selected').removeClass('is-selected')
            $('#show-single-family').parent().addClass('is-selected')
            event.preventDefault()
          })
        }

        if ($('#show-townhome').length) {
          google.maps.event.addDomListener(document.getElementById('show-townhome'), 'click', function (event) {
            for (let j = 0, l = infowindowList.length; j < l; j++) {
              infowindowList[ j ].close()
            }
            // Iterate through map markers, hide Actives, show ComingSoons. visible.
            for (let key in markers) {
              if (markers.hasOwnProperty(key)) { // Good practice when iterating through an object, to eliminate prototype properties
                // window.console && console.log(markers[key]['devStatus']);
                markers[ key ].setVisible(markers[ key ][ 'structure' ] === 'townhome')
              }
            }
            $('.gridControls li.is-selected').removeClass('is-selected')
            $('#show-townhome').parent().addClass('is-selected')
            event.preventDefault()
          })
        }
      }

      // We currently are not filtering on For Realtors page. We could.

      if (options.openAtStart) {
        // eslint-disable-next-line
        new google.maps.event.trigger(markers[ options.openAtStart ], 'click')
      }
    }

    function updateStaticMapUrl (mapOptions) {
      var map = document.getElementById('eahMap')
      var loc = mapOptions.mapLocations[ 0 ]
      var pos = loc.latitude + ',' + loc.longitude
      var base = 'https://maps.googleapis.com/maps/api/staticmap'
      var key = '&key=' + eah.map.API_KEY
      var center = '&center=' + pos
      var marker = '&markers=icon:' + encodeURI(getCommunityMarker(loc)) + '|' + pos
      var zoom = '&zoom=13&scale=2'
      var size = '&size=' + map.width + 'x' + map.height
      var style = '&' + staticMapStyles

      var url = base + '?' + key + center + zoom + size + marker + style

      map.src = url
    }

    function showStaticMap (mapOptions) {
      if (mapOptions.mapElement && mapOptions.mapLocations.length > 0) {
        updateStaticMapUrl(mapOptions)

        $(window).on('resize orientationchange', function () {
          updateStaticMapUrl(mapOptions)
        })
      }
    }

    const staticMapStyles = [
      'style=feature:poi|visibility:off',
      'style=feature:water|color:0x46bcec',
      'style=feature:landscape|color:0xf2f2f2',
      'style=feature:road|saturation:-100|lightness:45',
      'style=feature:road.highway|visibility:simplified',
      // 'style=feature:road.arterial|element:labels.icon|visibility:off',
      'style=feature:administrative|element:labels.text.fill|color:0x444444',
      'style=feature:transit|visibility:off'
    ].join('&')

    const mapStyles = [ {
      'featureType': 'water',
      'stylers': [ {
        'color': '#46bcec'
      }, {
        'visibility': 'on'
      } ]
    }, {
      'featureType': 'landscape',
      'stylers': [ {
        'color': '#f2f2f2'
      } ]
    }, {
      'featureType': 'road',
      'stylers': [ {
        'saturation': -100
      }, {
        'lightness': 45
      } ]
    }, {
      'featureType': 'road.highway',
      'stylers': [ {
        'visibility': 'simplified'
      } ]
    }, {
      'featureType': 'road.arterial',
      'elementType': 'labels.icon',
      'stylers': [ {
        'visibility': 'off'
      } ]
    }, {
      'featureType': 'administrative',
      'elementType': 'labels.text.fill',
      'stylers': [ {
        'color': '#444444'
      } ]
    }, {
      'featureType': 'transit',
      'stylers': [ {
        'visibility': 'off'
      } ]
    }, {
      'featureType': 'poi',
      'stylers': [ {
        'visibility': 'off'
      } ]
    } ]

    return {
      markers: markers,
      initialize: initialize,
      static: showStaticMap,
      ready: ready,
      createMap: createMap,
      API_KEY: API_KEY
    }
  }())
}(jQuery, window))
